import React from 'react';
import styled from 'styled-components';

export default function FilterCategoryButton({
	text,
	subText = '',
	isSubTextBold = false,
	isSelected,
	onClick,
}) {
	return (
		<Container
			className='filter-category-button'
			isSelected={isSelected}
			onClick={onClick}
		>
			<MainText>{text}</MainText>
			<SubText isSubTextBold={isSubTextBold}>{subText}</SubText>
		</Container>
	);
}

const Container = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	border: 1px solid
		${props =>
			props.isSelected
				? 'var(--sub-text-color)'
				: 'var(--button-border-color)'};
	border-radius: 5px;
	padding: 10px 19px;
	margin-bottom: 10px;
	background: ${props =>
		props.isSelected ? 'var(--selected-button-bg-color)' : 'none'};

	@media screen and (max-width: 1024px) {
		background: ${props =>
			props.isSelected ? 'var(--selected-button-bg-color)' : '#1F2428'};
		border: none;
	}

	@media screen and (max-width: 300px) {
		flex-direction: column;
	}
`;

const MainText = styled.span`
	color: var(--text-color);
	font-family: 'NotoSansMd';
	font-size: 12px;
`;

const SubText = styled.span`
	color: ${props =>
		props.isSubTextBold ? 'var(--text-color)' : 'var(--third-text-color)'};
	font-family: 'NotoSansRg';
	font-size: 10px;
	margin-top: 2px;
`;
